import { createFileRoute, useNavigate } from '@tanstack/react-router'

import {
    MyGrowerReportScreen,
    validateMyReportsSearch,
} from './-my-grower-report-screen'

/**
 * "Báo cáo" của tài khoản hộ trồng (M-45). Glue router ở đây, toàn bộ màn nằm
 * trong `-my-grower-report-screen` để test render được không cần dựng router.
 */
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/my-reports',
)({
    component: MyReportsPage,
    validateSearch: validateMyReportsSearch,
})

function MyReportsPage() {
    const navigate = useNavigate({ from: Route.fullPath })
    const search = Route.useSearch()

    return (
        <MyGrowerReportScreen
            search={search}
            onSearchChange={(next) =>
                void navigate({ search: () => next, replace: true })
            }
        />
    )
}
